import React, {useState} from 'react';
import {Box, Typography, Divider, IconButton} from '@mui/material';
import PayuForm from './PayuForm';
import {PAGELIST_ID} from '@jobseeker/common-core/constants';
import {Image} from '@jobseeker/lotus/components/Image';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';
import {useRouter} from 'next/router';
import {PaidProducts} from '@jobseeker/feature-payment/constant';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const ProButton = () => {
  const theme = useWrappedTheme();
  const router = useRouter();
  const isRetry = router.query.retryearlyapplicant === 'true';
  return (
    <Box sx={{marginTop: '16px'}}>
      <PayuForm
        key={'pro_membership_plan_button'}
        title={'Buy Now @1499 for 6 months'}
        refCode="0"
        pageId={PAGELIST_ID['jd']}
        tracking={{action: 'jsSCbanner', category: 'UpgradeToPro'}}
        product={PaidProducts.EARLY_APPLICANT}
        sx={{
          height: 60,
          width: 320,
          maxWidth: '100%',
          padding: '18px 27px',
          borderRadius: '8px',
          background: theme.palette.primary.main,
          boxShadow: isAppIimjobs
            ? '0 12px 25px 0 rgba(20, 144, 117, 0.33)'
            : ' 0 12px 25px 0 rgba(233,99,12,.33)',
          fontSize: '18px',
          fontWeight: '700',
          color: 'primary.contrastText',
          cursor: 'pointer',
        }}
        autoTrigger={isRetry}
      />
    </Box>
  );
};

const EarlyApplicant = () => {
  const theme = useWrappedTheme();
  const interceptor: any = useInterceptor();

  const {
    proMembership: {earlyApplicantPoints},
  } = interceptor;

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '700px',
        padding: {
          xs: '30px 18px 0px 19px',
          lg: '130px 31.3px 69px 135px',
        },
        backgroundImage: 'linear-gradient(to right, #f9f5ec 0%, #fff 100%)',
        borderTopLeftRadius: {
          xs: 0,
          lg: '150px',
        },
        display: 'flex',
        flexDirection: {
          xs: 'column-reverse',
          lg: 'row',
        },
      }}
    >
      <Box
        sx={{
          marginLeft: {},
          width: {
            xs: '100%',
            lg: '52%',
            '@media (max-width:1024px) and (min-width:1024px)': {
              width: '100%',
            },
          },
          height: 'max-content',
        }}
      >
        <Box
          sx={{
            backgroundColor: 'border.deepNavy',
            color: 'primary.contrastText',
            width: 'max-content',
            padding: '10px 11px',
            borderRadius: 1,
            marginBottom: 1.75,
            fontSize: theme.typography.pxToRem(12),
          }}
        >
          EARLY APPLICANT
        </Box>

        <Box sx={{marginBottom: 3}}>
          <Typography
            sx={{
              fontSize: '30px',
              fontWeight: 'bold',
              color: 'border.deepNavy',
              width: '95%',
              cursor: 'pointer',
            }}
          >
            Be an Early Applicant to the jobs you want
          </Typography>
          <Box
            sx={{
              color: '#000',
              lineHeight: 1.41,
            }}
          >
            {earlyApplicantPoints[0].description.map((desc, idx) => (
              <Box
                key={idx}
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  lineHeight: '30px',
                  marginTop: 3,
                }}
              >
                <Image
                  width={14}
                  height={16}
                  src="https://job-static.iimjobs.com/V2/static/media/iimjobsgreentick.7e6ffbb0.svg"
                  alt="tick"
                  style={{
                    marginRight: '8px',
                    marginTop: '7px', // Adjust to align with the text's line height
                  }}
                />
                <Box
                  sx={{
                    lineHeight: 1.41,
                  }}
                >
                  {desc}
                </Box>
              </Box>
            ))}

            <Box sx={{marginTop: 4, marginBottom: 5}}>
              <ProButton />
            </Box>
          </Box>
        </Box>

        {/* Expandable Sections */}
        {earlyApplicantPoints.slice(1).map((point, index) => (
          <Box key={index} sx={{marginBottom: 3}}>
            <Box
              sx={{
                display: 'flex',
                cursor: 'pointer',
                fontSize:
                  activeIndex === index + 1
                    ? theme.typography.pxToRem(30)
                    : theme.typography.pxToRem(16),
                fontWeight: activeIndex === index + 1 ? 'bold' : 'normal',
                color: 'border.deepNavy',
                transition: 'all 0.3s',
                marginBottom: 3,
              }}
              onClick={() =>
                setActiveIndex(activeIndex === index + 1 ? null : index + 1)
              }
            >
              <Typography
                sx={{
                  flex: 1,
                  width: '95%',
                  ...(activeIndex === index + 1
                    ? {
                        fontSize: '30px',
                        fontWeight: 'bold',
                      }
                    : {fontSize: '16px'}),
                }}
              >
                {point.heading}
              </Typography>
              <IconButton
                sx={{
                  width: 16,
                  height: 16,
                  backgroundColor: 'transparent', // Ensures no background color is applied
                  '&:hover': {
                    backgroundColor: 'transparent', // Keeps the background transparent on hover
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: '24px',
                    color: activeIndex === index + 1 ? '#7e7e7e' : '#333333',
                    // '&:hover': {
                    //   backgroundColor: '#fff6dc',
                    // },
                  }}
                >
                  {activeIndex === index + 1 ? '-' : '+'}
                </Typography>
              </IconButton>
            </Box>
            {activeIndex === index + 1 && (
              <Box
                sx={{
                  marginTop: 3,
                  color: '#000',
                  fontSize: theme.typography.pxToRem(17),
                  lineHeight: 1.41,
                  marginBottom: 3,
                }}
              >
                {point.description.map((desc, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: 'flex',
                      marginRight: 1.1,
                    }}
                  >
                    <Box
                      sx={{
                        minWidth: '20px',
                        marginTop: '8px',
                      }}
                    >
                      <Image
                        width={14}
                        height={14}
                        src="https://job-static.iimjobs.com/V2/static/media/iimjobsgreentick.7e6ffbb0.svg"
                        alt="tick"
                      />
                    </Box>
                    <Typography
                      sx={{
                        marginLeft: '8px', // Adds space between the tick icon and the text
                        fontSize: '16px', // Adjust as per your design requirements
                        lineHeight: '35px',
                      }}
                    >
                      {desc}
                    </Typography>
                  </Box>
                ))}
              </Box>
            )}
            {index < earlyApplicantPoints.length - 2 && <Divider />}
          </Box>
        ))}
      </Box>

      {/* Image Section */}
      <Box
        sx={{
          width: {
            xs: 300,
            lg: 390,
            '@media (max-width:1024px) and (min-width:1024px)': {
              width: 300,
            },
          },
          height: {
            xs: 352,
            lg: 420,
            '@media (max-width:1024px) and (min-width:1024px)': {
              height: 362,
            },
          },
          marginLeft: {
            xs: 'auto',
            lg: '80px',
          },
          marginRight: {
            xs: 'auto',
            lg: '80px',
          },
          marginBottom: {xs: '22px', md: '0'},
          marginTop: {lg: '50px'},
        }}
      >
        <Box
          sx={{
            '@media (max-width:1280px)': {
              '& img': {
                width: '340px',
                height: '365px',
              },
            },
            '@media (max-width:1024px)': {
              '& img': {
                width: '300px',
                height: '320px',
              },
            },
            '@media (max-width:768px)': {
              '& img': {
                width: '280px',
                height: '300px',
              },
            },
            '@media (max-width:375px)': {
              '& img': {
                width: '260px',
                height: '280px',
              },
            },
            '@media (max-width:360px)': {
              '& img': {
                width: '300px',
                height: '320px',
                marginTop: '20px',
              },
            },
          }}
        >
          <Image
            width={390}
            height={420}
            src={`${process.env.NEXT_PUBLIC_STATIC_IIMJOBS}/static/images/illustration@2x.webp`}
            alt="Early Applicant"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default EarlyApplicant;
